class LocationAccessService {

  constructor(ApiService, LocationAccessSchema) {
    this.ApiService = ApiService;
    this.LocationAccessSchema = LocationAccessSchema;
  }

  getAll() {
    var self = this;
    return self.ApiService.get('/api/locationaccesses')
        .then( (response) => { return response.data });
  }

}
LocationAccessService.$inject = ['ApiService', 'LocationAccessSchema'];
export default LocationAccessService;
